export default {
  ANNIVERSARY: 'ANNIVERSARY',
  END_OF_MONTH: 'END_OF_MONTH'
};
